module.exports = __webpack_public_path__ + "img/dog.4cf340a9.png";